import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import CusCard from '../../components/CusCard'

import { Row } from 'react-bootstrap';




class FleetOverviewSelection extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                {/* <Row>
                    <CusCard data1="Dashboard" data2="Summary" icon="truck" link="./FleetOverViewDashboardSummary" ></CusCard>
                    <CusCard data1="Fleet" data2="Bulletin" icon="shield-off" link="./FleetOverViewBulletIn"></CusCard>
                    <CusCard data1="Fleet" data2="Summary" icon="shield-off" link="./FleetOverViewFleetSummary"></CusCard>
                    <CusCard data1="Fleet" data2="Analysis" icon="alert-triangle" link="./FleetOverViewAnalysis"></CusCard>
                </Row> */}

                <Row>
                    <CusCard data1="Fleet Overview" data2="(Fleet-Level)" icon="truck" link="./FleetOverviewGraph" ></CusCard>
                    <CusCard data1="Fleet Overview" data2="(Vehicle-Level)" icon="alert-triangle" link="./FleetOverViewAnalysis"></CusCard>
                </Row>
            </div>
        );
    }
}


export default FleetOverviewSelection;